import { $api } from "@/services/api";

let instance = null;

class ModuleSetting {
    constructor() {
        if (instance) {
            return instance;
        }

        instance = this;
        this.apiKey = null;

        return instance;
    }

    async getApiKey() {
        if (!this.apiKey) {
            const response = await $api.module_settings.get({
                category: "CPN_INTERFACE",
                code: "cpn_api_key",
                is_expose_value: true,
                is_active: true
            });

            this.apiKey = response?.data[0]?.data_value;
        }

        return this.apiKey;
    }

    isAuthenticated() {
        const token = sessionStorage.getItem("accessToken");
        return !!token
    }

    deleteInstance() {
        instance = null;
    }
}

export function getModuleSettingInstance() {
    if (!instance) {
        instance = new ModuleSetting();
    }

    return instance;
}